<template>
  <v-row dense align="center">
    <v-col cols="12" sm="5" class="text-truncate">
      <div class="mt-1">
        <px-chip-codigo-interno :codigo-interno="produto.produto.codigo"/>
        <px-produto-descricao
          :show-codigo="false"
          :especificacao="produto.especificacaoProduto"
          :tooltip-truncate-chars="30"
          :produto="produto.produto"/>
          ({{ produto.unidadeMedida.descricao }})
      </div>
    </v-col>
    <v-col cols="12" sm="2" class="text-truncate">
      <div>
        {{ produto.valorMoedaConvertido.precoUnitario
          | currency('R$', produto.produto.casasDecimais) }}
        <div class="caption" v-if="isMoedaEstrangeira">
          {{ produto.precoUnitario | currency(
            simboloMoeda,
            produto.produto.casasDecimais,
            configuracaoFormatacaoMoeda
          ) }}
        </div>
      </div>
    </v-col>
    <v-col cols="12" sm="2">
      <px-input-decimal-number
        dense
        required
        :label="`Quantidade em ${produto.unidadeMedida.descricao}`"
        class="required rounded-tag-small"
        :precision="produto.produto.casasDecimais"
        :error="$v.produto.quantidade.$error"
        @blur="$v.produto.quantidade.$touch()"
        @click.stop.prevent=""
        v-model="produto.quantidade"/>
    </v-col>
    <v-col cols="12" sm="3">
      <px-autocomplete-nota-entrada
          dense
          @click.stop.prevent="() => {}"
          :class="`rounded-tag-small ${isTipoNotaEntradaRequired ? 'required' : ''}`"
          :error="$v.produto.tipoNotaEntrada.$error"
          @blur="$v.produto.tipoNotaEntrada.$touch()"
          v-model="produto.tipoNotaEntrada"/>
    </v-col>
  </v-row>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators';
import moedaMixin from '@/mixins/moeda-mixin';
import {
  isFieldRequiredEntityItens,
} from '@/modules/erp-campos/erp-campos-utils';
import validationMixin from '@/mixins/validation-mixin';

export default {
  mixins: [moedaMixin, validationMixin],
  props: {
    produto: {
      type: Object,
      required: true,
    },
    moeda: {
      type: String,
    },
    camposObrigatorios: Object,
  },
  computed: {
    isTipoNotaEntradaRequired() {
      return isFieldRequiredEntityItens('tipoNotaEntrada', this.camposObrigatorios);
    },
  },
  methods: {
    validate() {
      return this.validateForm();
    },
  },
  validations: {
    produto: {
      quantidade: {
        required,
        minValue(value) {
          return value > 0;
        },
      },
      tipoNotaEntrada: {
        required: requiredIf(function () {
          return this.isTipoNotaEntradaRequired;
        }),
      },
    },
  },
};
</script>
